import { useCallback } from "react";
import { useDispatch } from "react-redux";
import modalsPageActions from "store/modals/modalsPageActions";

const useModals = () => {
  const dispatch = useDispatch();

  const initModals = useCallback(() => {
    dispatch(
      modalsPageActions.addModals([
        {
          name: 'publish',
          onSubmit: () => null, // to omit closure, reassign it in Component
          onClose: () => dispatch(modalsPageActions.closeModal('publish')),
        },
        {
          name: 'update',
          onSubmit: () => null, // to omit closure, reassign it in Component
          onClose: () => dispatch(modalsPageActions.closeModal('update')),
        },
        {
          name: 'reconcile',
          onSubmit: () => null, // to omit closure, reassign it in Component
          onClose: () => dispatch(modalsPageActions.closeModal('reconcile')),
        },
        {
          name: 'remove',
          onSubmit: () => null,
          onClose: () => dispatch(modalsPageActions.closeModal('remove')),
        },
        {
          name: 'info',
          onSubmit: () => null,
          onClose: () => dispatch(modalsPageActions.closeModal('info')),
        },
        {
          name: 'conflict',
          onSubmit: () => null,
          onClose: () => dispatch(modalsPageActions.closeModal('conflict')),
        },
        {
          name: 'overlapping',
          onSubmit: () => dispatch(modalsPageActions.closeModal('overlapping')),
          onClose: () => dispatch(modalsPageActions.closeModal('overlapping')),
        },
      ])
    );
  }, [dispatch]);

  const cleanupModals = useCallback(() => {
    dispatch(modalsPageActions.removeModal('publish'));
    dispatch(modalsPageActions.removeModal('update'));
    dispatch(modalsPageActions.removeModal('reconcile'));
    dispatch(modalsPageActions.removeModal('remove'));
    dispatch(modalsPageActions.removeModal('info'));
    dispatch(modalsPageActions.removeModal('conflict'));
    dispatch(modalsPageActions.removeModal('overlapping'));
  }, [dispatch]);

  const openModal = useCallback((type, data) => {
    dispatch(modalsPageActions.openModal({ name: type, data }))
  }, [dispatch])

  return {
    initModals,
    openModal,
    cleanupModals,
  }
}

export default useModals;